export const RADIUS = {
  S: '5px',
  M: '10px',
}

export default {
  RADIUS,
}
